export const lines = {
  actions: {
    applyDiscount: 'Pas korting toe',
    duplicate: 'Kopiëren',
    editProduct: 'Product bewerken',
    removeDiscount: 'Verwijder korting',
  },
  advantage: {
    buttonLabel: 'Bekijk je voordeel',
    label: 'Jouw voordeel dankzij auteursrecht',
  },
  benefit: 'Voordeel',
  computerProgramAlert:
    "Factureer je een software-opdracht? Duid dan 'Computerprogramma-prestatie' aan. <faqLink>Meer weten over IT-opdrachten factureren?</faqLink>",
  creativeWork: {
    header: 'Soort prestatie',
    options: {
      CreativeComputer: { label: 'Computerprogramma prestatie', description: 'Je schrijft software of code voor je klant.' },
      CreativeGeneral: { label: 'Creatieve prestatie', description: 'Je maakt nieuw, origineel werk voor je klant.' },
      CreativeReuse: { label: 'Hergebruik', description: 'Je klant gebruikt bestaand werk van jou opnieuw of langer.' },
      CreativeSubcontracting: {
        label: 'Onderaanneming',
        description: 'Je factureert creatief werk door dat een andere freelancer voor jou deed.',
      },
      NonCreative: { label: 'Geen creatieve prestatie', description: 'Je factureert kosten zoals materiaal, huur of verplaatsingen.' },
    },
    placeholder: 'Creatief werk?',
  },
  description: {
    header: 'Beschrijving',
    placeholder: 'Beschrijving',
    placeholderProduct: 'Extra informatie',
  },
  discount: {
    free: 'Gratis',
    header: 'Korting',
  },
  discountType: {
    flatRate: '€',
    percentage: '%',
  },
  lineTotal: {
    header: 'Totaal',
  },
  new: {
    invoiceLine: 'Voeg factuurlijn toe',
    photoAlbum: 'Voeg fotoalbum toe',
    photoAlbumLine: 'Voeg fotoalbum lijn toe',
    product: 'Voeg product toe',
    productTooltip:
      'Ontdek <a href="https://knowledge.creativeshelter.be/producten-wat-zijn-ze-en-hoe-gebruik-je-ze" target="_blank">hier</a> wat producten zijn!',
    quotationLine: 'Voeg offertelijn toe',
    textLine: 'Voeg tekstregel toe',
  },
  photoAlbum: {
    deleteDialog: {
      description: "Weet je zeker dat je de sectie 'fotoalbum' wilt verwijderen? Dit verwijdert ook alle lijnen in deze sectie.",
      title: 'Fotoalbum verwijderen',
    },
    description: 'Voeg hier alle factuurlijnen toe die betrekking hebben op het fotoalbum.',
    tag: '6% btw',
    tagTooltip: 'Alle lijnen onder de sectie fotoalbum worden gefactureerd aan 6% btw.',
    title: 'Fotoalbum',
  },
  price: {
    header: 'Prijs (excl. btw)',
    productNotSyncTooltip: 'De prijs van deze lijn komt niet overeen met de prijs van het product. Klik om de prijs terug te zetten.',
  },
  productName: {
    label: 'Product',
    tooltip:
      'Deze lijn is op basis van een product. Wijzigingen kunnen, deze worden niet bewaard in je product, maar alleen op je factuur.',
  },
  quantity: {
    header: 'Aantal',
  },
  subtotal: 'Subtotaal',
  textLine: 'Tekstregel',
  total: 'Totaal',
  totalVat: 'Totaal btw',
  units: {
    characters_one: 'teken',
    characters_other: 'tekens',
    days_one: 'dag',
    days_other: 'dagen',
    halfDays_one: 'halve dag',
    halfDays_other: 'halve dagen',
    hours_one: 'uur',
    hours_other: 'uren',
    kilometers: 'km',
    none: '—',
    placeholder: 'Selecteer',
    words_one: 'woord',
    words_other: 'woorden',
  },
  vat: {
    header: 'Btw',
  },
  vatExported: 'Export',
  vatPercentage: 'Btw ({{ percentage }}%)',
  vatRegime: {
    exceptionallyExempt: 'Btw vrijgesteld',
    export: 'Btw export',
    shifted: 'Btw verlegd',
  },
  vatShifted: 'Btw verlegd',
  vatTooltip:
    'Op de factuur naar je klant rekenen we altijd btw, ongeacht je btw-status, omdat Creative Shelter een btw-plichtige onderneming is. <a href="https://knowledge.creativeshelter.be/wat-is-de-btw-vrijstellingsregeling-en-bestaan-er-nog-andere-regelingen" target="_blank">Lees er hier meer over!</a>',
};
